import styled from 'styled-components';
import type { Alignment } from '../../types';

export const EditorialColumnsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${process.env.IS_LEGACY ? ({ theme }) => theme.colors.mainContainer : 'none'};
  padding-inline: var(--page-margin);
  padding-block: var(--spacing-relative-xl);
  min-width: 0;

  p,
  div,
  span {
    word-break: break-word;
    overflow-wrap: anywhere;
    hyphens: auto;
  }

  /* @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    padding-inline: calc(2 * var(--page-margin));
  } */
`;

export const NumbersHeadlineContainer = styled.div`
  text-align: center;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    margin-block-end: var(--spacing-relative-2xl);
  }
`;

type LegalInfoContainerProps = {
  textAlignment: Alignment;
};
export const LegalInfoContainer = styled.div<LegalInfoContainerProps>`
  text-align: ${(props) => props.textAlignment};
`;

type TextHeadlineContainerProps = {
  alignment: Alignment;
};
export const TextHeadlineContainer = styled.div<TextHeadlineContainerProps>`
  text-align: ${(props) => props.alignment};
  margin-block-end: var(--spacing-relative-2xl);
`;
